import { MOCK_ACTIVE } from '@/config';

import { clearHtmlTags } from '@/helpers/HtmlHelper/clearHtmlTags';

import { ICardData, IEventConfig, IEventTemplate, IVitrineData } from './types';

export function getNestedValue(obj: any, path: string) {
  const keys = path.split('.');
  let current: any = obj;

  current = keys.reduce((acc, key) => {
    if (acc && typeof acc === 'object' && key in acc) {
      return acc[key];
    }
    return undefined;
  }, obj);

  return current;
}

export function processLoopCards(
  eventConfig: IEventConfig,
  vitrineData: IVitrineData,
) {
  if (
    !eventConfig.loopCards ||
    eventConfig.loopCards.length === 0 ||
    !vitrineData.cards
  ) {
    return null;
  }

  const loopedData: any = {};

  eventConfig.loopCards.forEach(loopPath => {
    const pathSegments = loopPath.split('.');
    let currentLevel: any = loopedData;

    for (let i = 0; i < pathSegments.length - 1; i += 1) {
      const segment = pathSegments[i];
      if (!currentLevel[segment]) {
        currentLevel[segment] = {};
      }
      currentLevel = currentLevel[segment];
    }

    const arrayKey = pathSegments[pathSegments.length - 1];
    currentLevel[arrayKey] = (vitrineData.cards ?? []).map(card => {
      const itemTemplateStructure = getNestedValue(
        eventConfig.template,
        loopPath,
      )?.['0'];

      if (!itemTemplateStructure) {
        console.warn(
          `Estrutura de item de loop não encontrada no template para o caminho: ${loopPath}`,
        );
        return {};
      }

      let itemTemplateString = JSON.stringify(itemTemplateStructure);

      itemTemplateString = itemTemplateString.replace(
        /{{data\.currentCard\.([^}]+)}}/g,
        (match, key) => {
          const value = card[key as keyof ICardData];
          return value !== undefined && value !== null ? String(value) : '';
        },
      );

      try {
        return JSON.parse(itemTemplateString);
      } catch (error) {
        console.error('Erro ao parsear template de item de loop:', error);
        return {};
      }
    });
  });

  return loopedData;
}

export function processTemplate(value: string, context: any): string {
  const combinedRegex = /{{(current|data|header)\.([^}]+)}}/g;

  return value.replace(combinedRegex, (match, source, path) => {
    let sourceObj;
    if (source === 'header') {
      sourceObj = context.vitrine.header;
    } else if (source === 'data') {
      sourceObj = context.data;
    } else {
      sourceObj = context.current;
    }

    const keys = path.split('.');
    const val = keys.reduce(
      (acc: any, key: any) =>
        acc && typeof acc === 'object' && key in acc ? acc[key] : '',
      sourceObj,
    );

    if (val === undefined || val === null) {
      return '';
    }
    return typeof val === 'object'
      ? JSON.stringify(val)
      : clearHtmlTags(String(val));
  });
}

export function processValue(
  value: string | string[] | Record<string, any>,
  context: any,
): any {
  let newValue = value;

  if (typeof newValue === 'string') {
    newValue = processTemplate(newValue, context);

    newValue = newValue.replace(/{{title}}/g, () => {
      return clearHtmlTags(context.vitrine?.title) || '';
    });

    newValue = newValue.replace(/{{current}}/g, () => {
      return clearHtmlTags(context.current?.current) || '';
    });

    try {
      if (
        (newValue.startsWith('{') && newValue.endsWith('}')) ||
        (newValue.startsWith('[') && newValue.endsWith(']'))
      ) {
        return JSON.parse(newValue);
      }
    } catch (e) {
      return newValue;
    }
  } else if (Array.isArray(newValue)) {
    return newValue.map(item => processValue(item, context));
  } else if (newValue !== null && typeof newValue === 'object') {
    const newObj: Record<string, any> = {};
    Object.keys(newValue).forEach(k => {
      newObj[k] = processValue((newValue as Record<string, any>)[k], context);
    });
    return newObj;
  }

  return newValue;
}

export function formatEventData(template: IEventTemplate, context: any) {
  const result = JSON.parse(JSON.stringify(template));

  try {
    return processValue(result, context);
  } catch (error) {
    console.error('Erro ao parsear template de evento:', error);
    return null;
  }
}

export function eventPushLogger(eventData: any) {
  if (MOCK_ACTIVE) {
    console.group('[AMPLITUDE TAG] dataLayer push');
    console.log(eventData);
    console.log('event string', JSON.stringify(eventData));
    console.groupEnd();
  }
}
